import React from 'react';
import Lottie from 'lottie-react';
import LoaderNew from "../../../Assets/loader/mmc_loader.json"

const WebLoader = (props) => {


    return (

        <div className='d-flex justify-content-center align-items-center' style={{ height: "100vh", width: "100%" }}>
            {/* <Lottie
                className='load lottieLoader'
                animationData={LoaderNew}
                loop={false}
                speed={2}
                
                autoplay={true}
            /> */}
        </div>

    );
};

export default WebLoader;